import { Get } from "../utils/http-utils";

export const getDataitemsForDevice = async (queryParams) => {
    return Get("/data-items", queryParams)
        .then((data) => {
            return data;
        })
        .catch((err) => {
            return [];
        });
}